import { CommonModule } from '@angular/common';
import {
  NgModule,
  forwardRef,
  Component,
  AfterViewInit,
  ChangeDetectorRef,
  AfterViewChecked,
  ChangeDetectionStrategy,
  Injector,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { RadioButton, RadioControlRegistry } from 'primeng/radiobutton';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

export const RADIO_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => RfRadioButton),
  multi: true,
};

@Component({
  selector: 'rf-radioButton',
  templateUrl: './radiobutton.html',
  providers: [RADIO_VALUE_ACCESSOR],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RfRadioButton extends RadioButton {
  // PrimeNG 16 queries '#input'; this template names the native input '#rb' (as PrimeNG 15 did).
  @ViewChild('rb') inputViewChild: ElementRef;
}

@NgModule({
  imports: [CommonModule],
  exports: [RfRadioButton],
  declarations: [RfRadioButton],
})
export class RfRadioButtonModule {}
